// Web shim for @sendbird/react-native-scrollview-enhancer
import React from 'react';
import { ScrollView } from 'react-native';

export const ScrollViewEnhancer = ScrollView;
export default ScrollView;
export const EnhancedScrollView = ScrollView;
